export const STANDARDS_LIBRARY_PATH = '/curriculum/standards';
export const STANDARDS_FIND_PATH = '/curriculum/standards/find';
